import React from "react";
import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import ScheduledActionList from "../../../components/scheduledActions/ScheduledActionList";
import { useControlOptions } from "../../../components/scheduledActions/scheduledActionDefaults";
import { useTimedActionsCrud } from "../../../components/scheduledActions/useTimedActionsCrud";
import { useScheduledActionPermissions } from "../../../components/scheduledActions/useScheduledActionPermissions";

interface OrgScheduledActionsDrawerProps {
  open: boolean;
  onClose: () => void;
  organizationId: string;
  organizationIds?: string[];
}

function OrgScheduledActionsDrawer({
  open,
  onClose,
  organizationId,
  organizationIds = undefined,
}: OrgScheduledActionsDrawerProps): React.ReactElement {
  const [t] = useTranslation("global");
  const { canDelete } = useScheduledActionPermissions();

  // Drawer is read + delete only; create/edit/toggle handlers go unused here and
  // their alert blocks stay dormant because POST/PUT never fire.
  const { actions, isFetching, fetchError, handleDelete, alerts } = useTimedActionsCrud(
    { kind: "orgs", organizationId, organizationIds },
    { enabled: open },
  );

  const controlOptions = useControlOptions();

  return (
    <Drawer
      title={t("scheduledActions.orgDrawerTitle", "Scheduled Actions")}
      placement="right"
      width={720}
      open={open}
      onClose={onClose}
    >
      <ScheduledActionList
        actions={actions}
        loading={isFetching}
        error={fetchError}
        onDelete={canDelete ? handleDelete : undefined}
        controlOptions={controlOptions}
      />
      {alerts}
    </Drawer>
  );
}

export default OrgScheduledActionsDrawer;
